// src/components/HeroBanner/ListHeroBanner.js
import React, { useEffect, useCallback, useState } from "react";
import { Button, Card, Container, Row, Col, Badge } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import MaterialReactTable from "material-react-table";
import { toast, ToastContainer } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  fetchHeroBanner,
  deleteHeroBanner,
  toggleHeroBannerStatus,
} from "../../../Redux/heroBannerReduce";

function ListHeroBanner() {
  const [alert, setAlert] = useState(null);
  const navigate = useHistory();
  const dispatch = useDispatch();
  const [heroBanners, setHeroBanners] = useState([]);

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>
          <i className="fas fa-check-circle"></i>
          {msg}
        </strong>,
      );
    else
      toast.error(
        <strong>
          <i className="fas fa-exclamation-circle"></i>
          {msg}
        </strong>,
      );
  };

  const columns = [
    {
      header: "Nom",
      accessorKey: "name",
      Cell: ({ cell }) => cell.getValue() || "-",
    },
    {
      header: "Description",
      accessorKey: "description",
      Cell: ({ cell }) => {
        const description = cell.getValue();
        return description?.length > 50
          ? `${description.substring(0, 50)}...`
          : description || "-";
      },
    },
    /* {
      header: "Image",
      accessorKey: "img",
      Cell: ({ cell }) => (
        <img
          src={cell.getValue()}
          alt="hero banner"
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "5px",
          }}
        />
      ),
    },
    {
      header: "Statut",
      accessorKey: "isActive",
      Cell: ({ cell }) => (
        <Badge bg={cell.getValue() ? "success" : "secondary"}>
          {cell.getValue() ? "Actif" : "Inactif"}
        </Badge>
      ),
    }, */
    {
      accessorKey: "id",
      header: "Actions",
      Cell: ({ row }) => (
        <div className="actions-right block_action">
          <Button
            onClick={() =>
              handleToggleActive(row.original.id, row.original.isActive)
            }
            variant={row.original.isActive ? "warning" : "success"}
            size="sm"
            className="btn-link"
            title={row.original.isActive ? "Désactiver" : "Activer"}
          >
            <i
              className={`fa ${row.original.isActive ? "fa-toggle-off" : "fa-toggle-on"}`}
            />
          </Button>
          <Button
            onClick={() =>
              navigate.push("/heroBanner/update/" + row.original.id)
            }
            variant="warning"
            size="sm"
            className="text-warning btn-link edit"
            title="Modifier"
          >
            <i className="fa fa-edit" />
          </Button>
          <Button
            onClick={() => confirmDelete(row.original.id)}
            variant="danger"
            size="sm"
            className="text-danger btn-link delete"
            title="Supprimer"
          >
            <i className="fa fa-trash" />
          </Button>
        </div>
      ),
    },
  ];

  const getHeroBanners = useCallback(async () => {
    const response = await dispatch(fetchHeroBanner());
    setHeroBanners(response.payload);
  }, [dispatch]);

  const handleToggleActive = async (id, currentStatus) => {
    try {
      await dispatch(toggleHeroBannerStatus(id));
      notify(
        1,
        `Hero banner ${currentStatus ? "désactivé" : "activé"} avec succès`,
      );
      getHeroBanners();
    } catch (error) {
      notify(2, "Erreur lors du changement de statut");
    }
  };

  const confirmDelete = (id) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Êtes-vous sûr de vouloir supprimer cette hero banner?"
        onConfirm={() => deleteHeroBanner(id)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      />,
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const deleteHeroBanner = async (id) => {
    try {
      await dispatch(deleteHeroBanner(id));
      notify(1, "Hero banner supprimée avec succès");
      getHeroBanners();
      hideAlert();
    } catch (error) {
      notify(2, "Erreur lors de la suppression");
    }
  };

  useEffect(() => {
    getHeroBanners();
  }, [getHeroBanners]);

  function ajouter() {
    navigate.push("/heroBanner/add");
  }

  return (
    <Container fluid>
      {alert}
      <ToastContainer />
      <Row>
        <Col md="8">
          <Button
            className="btn-wd mr-1 float-left"
            type="button"
            variant="success"
            onClick={ajouter}
          >
            <span className="btn-label">
              <i className="fas fa-plus"></i>
            </span>
            Ajouter une hero banner
          </Button>
        </Col>
        <Col md="12">
          <h4 className="title">Liste des hero banners</h4>
          <Card>
            <Card.Body>
              <MaterialReactTable
                columns={columns}
                data={heroBanners}
                enableColumnActions={true}
                enableColumnFilters={true}
                enablePagination={true}
                enableSorting={true}
                enableBottomToolbar={true}
                enableTopToolbar={true}
                muiTableBodyRowProps={{ hover: false }}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ListHeroBanner;
